<data-table (custom)="onSelect($event)" *ngIf="data" [columns]="columns" [dataProviderParams]="params" [hideSearch]="true"
                [validator]="{ validate:'_id',  target: this.data['assignedPackageInstalledApps'] }" alternative_icon=null icon="add_circle"
                [dataProvider]="packageInstalledAppService" title="Assign secured App to Group" [noCard]="true"></data-table>

<p><i>Your packageInstalledApp is not listed?<br>Enable it with the flag <b>isSecured</b> in the package configuration.</i></p>

<div class="button-right-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>cancel</button>
</div>
